import React, { useEffect } from 'react';
import { Grid, MenuItem } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { useContext } from "react"
import { QuoteContextStore } from '../../../../context/QuoteContext/QuoteContext';
import { ControlledTextField } from '../../../Core/Form/ControlledFields';
import { prettyLimitPrice } from '../../../../services/utils';
import { useFormContext } from 'react-hook-form';

const LiabiltyCoverageSelect = () => {
    const {register} = useFormContext();
    const { coverages : { options, selected: { liability_coverage } } , changeLiabilityCoverage,locked_quote} = useContext(QuoteContextStore);
    
    if(!options) {
        return <Skeleton height={100} width={'100%'} />
    }

    const { liability_coverages } = options;
    return  <ControlledTextField disabled={locked_quote} fullWidth select name="liability_coverage">
        <MenuItem selected disabled value="default" className="gray">
            <Grid container>
                <span className='gray'>Liability Insurance</span>
            </Grid>
        </MenuItem>
        {Object.keys(liability_coverages).map(id => (
        <MenuItem onClick={()=> changeLiabilityCoverage(id, liability_coverages[id])} value={id} key={id}>
            <Grid container wrap='nowrap'>
                <Grid container item direction='column' alignItems='center'>
                    <span>Per accident</span>
                    <span className='bold'>{prettyLimitPrice(liability_coverages[id].liability_limit)}</span>
                </Grid>
                <span className='vertical-divider'/>
                <Grid container item direction='column' alignItems='center'>
                    <span>Per passenger</span>
                    <span className='bold'>{liability_coverages[id].passenger_limit ? prettyLimitPrice(liability_coverages[id].passenger_limit) : "Not Covered"}</span>
                </Grid>
            </Grid>
        </MenuItem>))}
    </ControlledTextField>
}

export default LiabiltyCoverageSelect;